import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
  output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SiaTranslatePipe } from '../../pipes/sia-translate.pipe';

@Component({
  selector: 'sia-search-box',
  standalone: true,
  imports: [FormsModule, SiaTranslatePipe],
  templateUrl: './sia-search-box.component.html',
  styleUrl: './sia-search-box.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiaSearchBoxComponent {
  readonly fontSize = input<string>('1rem');
  readonly iconSize = input<string>('24px');
  readonly searchDisabled = input<boolean>(false);
  readonly surfaceClass = input<string>('surface-low');
  readonly aiSearch = input<boolean>(false);
  readonly hideSearchIcon = input<boolean>(false);
  readonly searchClicked = output<string | undefined>();

  readonly searchExp = model<string | undefined>(undefined);
  private hasEmittedInitialSearchExp = false;

  onSearchExpChange(value: string | undefined) {
    this.searchExp.set(value);
  }

  search() {
    const value = this.searchExp();
    this.searchClicked.emit(value);
  }

  clear() {
    this.searchExp.set('');
    const value = this.searchExp();
    this.searchClicked.emit(value);
  }
}
